import React, { useState } from 'react'
import { Button } from '../../lib/ui/button'
import { Toaster } from '../../lib/ui/toast'
import {
  ArrowUpTrayIcon,
  DocumentTextIcon,
  PlusIcon,
} from '@heroicons/react/24/outline'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../lib/ui/dialog'
import DropzoneResumeUpload from './DropzoneResumeUpload'
import useTranslation, {
  TranslationProvider,
} from '../shared/TranslationProvider'
import translations from './locales.json'

const NewResumeOptions = ({ uploadResumeClick }) => {
  const { t } = useTranslation('NewResumeModal')
  return (
    <div className="px-4 pb-4">
      <div className="mb-4 text-lg font-medium">
        {t('choose_your_approach')}
      </div>
      <div className="pb-4">{t('create_resume_description')}</div>
      <div className="pb-4">
        <a
          href="/resume/builder/new"
          className="flex h-28 w-full flex-row rounded-2.5xl bg-lily-blue text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <PlusIcon className="w-10" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="text-roboto-slab text-xl font-medium">
              {t('create_new_resume')}
            </div>
            <div>{t('choose_a_blank_template')}</div>
          </div>
        </a>
      </div>
      <div className="pb-4">
        <button
          onClick={uploadResumeClick}
          className="flex h-28 w-full flex-row rounded-2.5xl bg-lily-blue text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <ArrowUpTrayIcon className="w-10" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="text-roboto-slab text-xl font-medium">
              {t('upload_your_resume')}
            </div>
            <div>{t('upload_valid_formats')}</div>
          </div>
        </button>
      </div>
    </div>
  )
}

const NewResumeModalInner = (props) => {
  const { t } = useTranslation('NewResumeModal')
  const { open, toggleOpen, uploadResumeMode, uploadResumeClick, locale } =
    props

  return (
    <Dialog
      open={open}
      onOpenChange={toggleOpen}
      className="!w-auto rounded-2xl lg:max-w-[37rem] xl:max-w-[37rem]"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button>{t('create_a_new_resume')}</Button>
      </DialogTrigger>
      <DialogContent
        className="font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">
              {t('create_your_resume')}
              <DocumentTextIcon className="ml-2 inline w-6" />
            </h2>
          </DialogTitle>
        </DialogHeader>
        {!uploadResumeMode && (
          <NewResumeOptions uploadResumeClick={uploadResumeClick} />
        )}
        {uploadResumeMode && <DropzoneResumeUpload locale={locale} />}
      </DialogContent>
      <Toaster />
    </Dialog>
  )
}

const NewResumeModal = (props) => {
  const { locale } = props
  const [open, setOpen] = useState(false)
  const [uploadResumeMode, setUploadResumeMode] = useState(false)

  const uploadResumeClick = () => {
    setUploadResumeMode(true)
  }

  const toggleOpen = () => {
    setOpen(!open)
    setUploadResumeMode(false)
  }

  return (
    <TranslationProvider
      locale={locale}
      scope="javascript.components.ResumeBuilder"
      translations={translations}
    >
      <NewResumeModalInner
        open={open}
        toggleOpen={toggleOpen}
        uploadResumeMode={uploadResumeMode}
        uploadResumeClick={uploadResumeClick}
        locale={locale}
      />
    </TranslationProvider>
  )
}
export default NewResumeModal
